export default {
      id: "mail-usage",
      viewBox: "0 0 10 7.312",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#mail",
      toString: function () {
        return this.url;
      }
    }